import { AxiosError } from 'axios'

export const getSendMessageAlert = (e: unknown) => {
  if (e instanceof AxiosError && e.errors.getError('media_url')) {
    return e.errors.getError('media_url')
  }

  return 'Something went wrong sending your message. Please try again'
}
